import React from "react";
import UnderConstructionPage from "./UnderConstructionPage";

// Phase F.6 Batch C — Parts & Procurement is now an Add-On (Under Construction).
// The live workflow (PO creation, supplier sync, RFQ comparison) will ship when
// the user greenlights it. For now, the page is a clear UC stub so it's obvious
// from the sidebar badge ("UC") and the page itself that this is a future module.
export default function PartsProcurement() {
  return (
    <UnderConstructionPage
      title="Parts & Procurement"
      description="A future Add-On module for purchase orders, supplier RFQs, and vendor catalogs. We'll wire this up once you're ready to onboard procurement workflows — stay tuned."
    />
  );
}
